<template>
  <div class="page-not-found">
    <div class="page-not-found__content">
      <div class="page-not-found__icon">
        <SearchX :size="100" />
      </div>

      <h1 class="page-not-found__title">
        {{ $t('Page not found') }}
      </h1>
      <p class="page-not-found__description">
        {{ $t('You followed the incorrect reference or the page was removed.') }}
      </p>
    </div>
  </div>
</template>

<script>
import { SearchX } from 'lucide-vue'

export default {
  name: 'PageNotFound',
  components: {
    SearchX,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common-imports.scss';

.page-not-found {
  display: grid;
  align-content: center;
  height: 100%;
  padding: 100px 0;

  &__icon {
    color: $GreenM;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  &__title {
    font-size: 24px;
    font-weight: 500;
    text-align: center;
  }

  &__description {
    text-align: center;
    font-size: 16px;
    color: $Gray3;
    padding: 0 16px;
  }
}
</style>
